import { Box, Slider } from '@mui/material';
import { styled } from '@mui/material/styles';

const CustomSlider = styled(Slider)({
	color: '#6cadff',
	height: `${4/360 * 100}vw`,
	'& .MuiSlider-rail': {
		opacity: 0.2,
	},
	'& .MuiSlider-thumb': {
		height: 24,
		width: 24,
		backgroundColor: 'currentColor',
		//border: '2px solid currentColor',
		'&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
			boxShadow: 'inherit',
		},
		'&:before': {
			display: 'none',
		},
	},
	'& .MuiSlider-valueLabel': {
		lineHeight: 1.2,
		fontSize: 12,
		background: 'unset',
		padding: 0,
		width: 32,
		height: 32,
		borderRadius: '50% 50% 50% 0',
		backgroundColor: '#52af77',
		transformOrigin: 'bottom left',
		transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
		'&:before': { display: 'none' },
		'&.MuiSlider-valueLabelOpen': {
			transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
		},
		'& > *': {
			transform: 'rotate(45deg)',
		},
	},
});

function ScaleBar({ value, onUpdate }) {
	return (
		<Box
			display='flex'
			justifyContent='center'
			alignItems='center'
			sx={{
				width: `${320/360 * 100}vw`,
				height: `${64/360 * 100}vw`,
				borderWidth: `${0.6/360 * 100}vw`,
				borderColor: '#e8e8e8',
				borderStyle: 'solid',
				borderRadius: `${10/360 * 100}vw`,
				boxShadow: `${2/360 * 100}vw ${2/360 * 100}vw ${12/360 * 100}vw 0 #0f000000`,
				padding: `${20/360 * 100}vw`,
				marginTop: `${10/360 * 100}vw`,
			}}
		>
			<CustomSlider
				value={value}
				valueLabelDisplay="off"
				track={false}
				onChange={(event, newValue) => onUpdate(newValue)}
			/>
		</Box>
	);
}

export default ScaleBar;
